import Vue from "vue";
import Vuex from "vuex";
import * as mutation from "./mutation-types"
import * as action from "./action-types"
import router from "./router"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const vm = new Vue()
//手机端用户登录后的侧边栏
let mobileSideItems = [
    {
        src: "group",
        name: "分组列表",
        authorCode: "_09",
        queryAuthor: "_0901_",
        path: '/home/group/list',
        sceneList: [
            {
                name: "组内设备",
                path: "/home/group/dev",
                author: "_0201_",
                queryAuthor: "3_2-1",
                updateAuthor: "3_3-0",
            }
        ]
    }
]
let busSideItems = [
    {
        src: "group",
        name: "分组列表",
        authorCode: "_09",
        queryAuthor: "_0901_",
        path: '/home/group/list',
        sceneList: [
            {
                name: "组内设备",
                path: "/home/group/dev",
                author: "_0201_",
                queryAuthor: "3_2-1",
                updateAuthor: "3_3-0",
            }, {
                name: "应用管理",
                path: "/home/group/app/manage",
                author: "_0201_",
                queryAuthor: "3_4-1",
                updateAuthor: "3_4-0",
            }
        ]
    }, {
        src: "app",
        name: "应用列表",
        authorCode: "_09",
        queryAuthor: "_0901_",
        path: '/home/app/list',
        sceneList: [
            {
                name: "应用上传",
                path: "/home/app/upload",
                author: "_0301_"
            }, {
                name: "应用详情",
                path: "/home/app/detail",
                author: "_0301_"
            }, {
                name: "所属分组",
                path: "/home/app/group",
                author: "_0301_"
            }
        ]
    }, {
        src: "log",
        name: "文件分发",
        authorCode: "_09",
        queryAuthor: "_0901_",
        path: '/home/file/list',
        sceneList: [
           {
                name: "文件分发",
                path: "/home/file/issue",
                author: "_0201_",
                queryAuthor: "4_2-1",
                updateAuthor: "4_2-0",
            }
        ]
    }
]
let sideItems = [
    {
        src: "overview",
        name: "预览",
        authorCode: "_09",
        queryAuthor: "_0901_",
        path: '/home/overview'
    }, {
        src: "dev",
        name: "设备管理",
        guide: true,
        authorCode: "_02",
        queryAuthor: "_0201_",
        updateAuthor: "_0200_",
        children: [
            {
                name: "设备池",
                path: '/home/deviceCase',
                author: '_0201_',
                queryAuthor: "1-1",
                updateAuthor: "1-0",
                isAdmin: true,
                sceneList: [
                    {
                        name: "设备池详情",
                        path: "/home/deviceCaseDetail",
                        author: "_0201_",
                        queryAuthor: "1_1-1",
                        updateAuthor: "1_1-0",
                    }, {
                        name: "池内设备",
                        path: "/home/deviceCaseDev",
                        author: "_0201_",
                        queryAuthor: "1_2-1",
                        updateAuthor: "1_2-0",
                    }
                ]
            },
            {
                name: "设备列表",
                path: '/home/deviceList',
                author: '_0201_',
                queryAuthor: "2-1",
                updateAuthor: "2-0",
            },
            {
                name: "分组列表",
                path: '/home/group/list',
                author: '_0201_',
                queryAuthor: "3-1",
                updateAuthor: "3-0",
                sceneList: [
                    {
                        name: "增减设备",
                        path: "/home/group/dev/manage",
                        author: "_0201_",
                        queryAuthor: "3_1-1",
                        updateAuthor: "3_1-0",
                    }, {
                        name: "组内设备",
                        path: "/home/group/dev",
                        author: "_0201_",
                        queryAuthor: "3_2-1",
                        updateAuthor: "3_3-0",
                    }, {
                        name: "应用管理",
                        path: "/home/group/app/manage",
                        author: "_0201_",
                        queryAuthor: "3_4-1",
                        updateAuthor: "3_4-0",
                    }
                ]
            },
            {
                name: "文件分发",
                path: '/home/file/list',
                author: '_0201_',
                queryAuthor: "4-1",
                updateAuthor: "4-0",
                sceneList: [
                   {
                        name: "文件分发",
                        path: "/home/file/issue",
                        author: "_0201_",
                        queryAuthor: "4_2-1",
                        updateAuthor: "4_2-0",
                    }, {
                        name: "分发记录",
                        path: "/home/file/record",
                        author: "_0201_",
                        queryAuthor: "4_3-1",
                        updateAuthor: "4_3-0",
                    }
                ]
            },
            {
                name: "故障设备列表",
                path: '/home/faultDeviceList',
                author: '_0201_',
                queryAuthor: "7-1",
                updateAuthor: "7-0",
            },
        ]
    }, {
        src: "app",
        name: "应用管理",
        guide: true,
        authorCode: "_03",
        queryAuthor: "_0301_",
        updateAuthor: "_0300_",
        children: [
            {
                name: "应用列表",
                path: '/home/app/list',
                author: '_0301_',
                queryAuthor: "8-1",
                updateAuthor: "8-0",
                sceneList: [
                    {
                        name: "应用上传",
                        path: "/home/app/upload",
                        author: "_0301_"
                    }, {
                        name: "应用详情",
                        path: "/home/app/detail",
                        author: "_0301_"
                    }, {
                        name: "所属分组",
                        path: "/home/app/group",
                        author: "_0301_"
                    }
                ]
            }, {
                name: "应用恢复",
                path: "/home/app/recover",
                author: "_0301_",
                queryAuthor: "9-1",
                updateAuthor: "9-0",
            }, {
                name: "应用监控",
                path: "/home/app/monitor",
                author: "_0301_",
                queryAuthor: "10-1",
                updateAuthor: "10-0",
            }
        ]
    }, {
        src: "log",
        name: "日志管理",
        guide: true,
        authorCode: "_05",
        queryAuthor: "_0501_",
        updateAuthor: "_0500_",
        children: [
            {
                name: "操作日志",
                path: '/home/log/operation',
                author: '_0501_',
                queryAuthor: "11-1",
                updateAuthor: "11-0",
            },
            {
                name: "调度日志",
                path: '/home/log/dispatch',
                author: '_0501_',
                queryAuthor: "12-1",
                updateAuthor: "12-0",
            },
            {
                name: "分组日志",
                path: '/home/log/group',
                author: '_0501_',
                queryAuthor: "13-1",
                updateAuthor: "13-0",
            },
            {
                name: "运维日志",
                path: '/home/log/ops',
                author: '_0501_',
                queryAuthor: "14-1",
                updateAuthor: "14-0",
            }
        ]
    }, {
        src: "user",
        name: "用户管理",
        guide: true,
        authorCode: "_01",
        queryAuthor: "_0101_",
        updateAuthor: "_0100_",
        children: [
            {
                name: "用户列表",
                path: '/home/user/list',
                author: '_0101_',
                queryAuthor: "15-1",
                updateAuthor: "15-0",
            },
            {
                name: "用户组列表",
                path: '/home/user/group/list',
                author: '_0101_',
                queryAuthor: "16-1",
                updateAuthor: "16-0",
            }
        ]
    }, {
        src: "system",
        name: "系统管理",
        guide: true,
        authorCode: "_00",
        queryAuthor: "_0001_",
        updateAuthor: "_0000_",
        children: [
            {
                name: "系统信息",
                path: '/home/system',
                author: '_0001_',
                queryAuthor: "17-1",
                updateAuthor: "17-0",
                sceneList: [
                    {
                        name: "云机升级",
                        path: "/home/system/cardupdate",
                        author: "_0001_",
                        queryAuthor: "17-1-1",
                        updateAuthor: "17-1-0",
                    }, {
                        name: "升级记录",
                        path: "/home/system/cardupdaterecord",
                        author: "_0001_",
                        queryAuthor: "17-2-1",
                        updateAuthor: "17-2-0",
                    }
                ]
            },
            {
                name: "日志服务器配置",
                path: '/home/system/log',
                author: '_0001_',
                queryAuthor: "18-1",
                updateAuthor: "18-0",
            },
            {
                name: "远程运维",
                path: '/home/system/ops',
                author: '_0001_',
                queryAuthor: "19-1",
                updateAuthor: "19-0",
            }
        ]
    }
]

const state = {
    loginState: false,
    loginForwardPath: "/home",
    extranetIp: "",
    webIp: "",
    isMobile: false,
    userInfo: {
        id: 0,
        username: '',
        save: false,
        token: '',
        authority: '_0000_,_0001_,_0100_,_0101_,_0200_,_0201_,_0300_,_0301_,_0400_,_0401_,_0500_,_0501_'
    },
    isAdmin: false,
    isAdminRoot: false,
    caseInfo: {
        id: 0,
        caseNo: "",
        initialPort: 0,
        adbPort: 0,
        route: "",
        netmask: "",
        dns: "",
        isStatus: 0,
        isLock: 1,
        nodeIp: "",
        nodeIpBak: "",
        remark: "",
        deviceNum: 0,
        deviceNumIsDistributed: 0,
        deviceNumIsFault: 0,
        ntpAddress: ""
    },
    appInfo: {
        id: "",
        appId: ""
    },
    groupInfo: {
        id: 0
    },
    fun: null,
    funList: [],
    changeFun: null,
    guide: 0,
    sideCheck: 0,
    sceneCheck: 0,
    sceneChildCheck: 0,
    sideItems: sideItems,
    busSideItems: busSideItems,
    mobileSideItems: mobileSideItems,
    loginTimeout: false,
    logGroupId: '',
    groupDevShowMode: false, // true为列表，false为预览
    deviceWindowMode: [],
    cameraInfo: [],
    cameraWeight: 0,
    cameraShow: true,
    cameraLeft: 0,
    cameraTop: 0,
    videoInfo: [],
    sideInfo: {
        item: null,
        child: null,
        scene: null
    },
    needLicense: false,
    needLayer: true,
    licenseInfo: {
        customerId: '',
        deviceNum: 0,
        containerMax: 0,
        secondsLeft: 0,
        hasLayer: 0,
        service: []
    },
    licenseUpdate: false,
    devSyncInfo: {
        mainDev: '',
        syncDevs: []
    },
    latelyPages: [],
    normalPageInfo: {},
    helpIndex: 0,
    groupName: '',
    devInfo: {
        deviceNum: 0,
        badNum: 0,
        streamNum: 0
    },
    ssh: {
        start: false,
        show: false,
    },
    loginNow: true,
    displayMode: 0,
    scaleMode: 150,
    sortMode: 0,
    refreshTime: 0,
    fileRecordId: null,
    fileIssueInfo: null,
    mirrorRecord: null,
    displaySide: true
}

let admin = {
    src: "admin",
    name: "后台管理",
    authorCode: "_00",
    queryAuthor: "_0001_",
    updateAuthor: "_0000_",
    children: [
        {
            name: "FAQ",
            path: '/home/faq',
            author: '_0001_'
        }, {
            name: "功能介绍大类",
            path: '/home/fun/class',
            author: '_0001_'
        }, {
            name: "功能介绍",
            path: '/home/fun',
            author: '_0001_',
            sceneList: [
                {
                    name: "添加功能介绍",
                    path: "/home/fun/add",
                    author: "_0001_"
                }, {
                    name: "修改功能介绍",
                    path: "/home/fun/change",
                    author: "_0001_"
                }
            ]
        }
    ]
}

let help = {
    src: "",
    name: "",
    authorCode: "_00",
    queryAuthor: "_0001_",
    updateAuthor: "_0000_",
    children: [
        {
            name: "FAQ",
            path: '/home/help/faq',
            author: '_0200_'
        }, {
            name: "功能介绍",
            path: '/home/help/fun',
            author: '_0200_',
            sceneList: [
                {
                    name: "功能介绍文档",
                    path: "/home/help/fun/show",
                    author: "_0200_"
                }
            ]
        }
    ]
}

// state.sideItems.push(admin)
state.sideItems.push(help)

for (let item in state) {
    sessionStorage.getItem(item) ? state[item] = JSON.parse(sessionStorage.getItem(item)) : false;
}
// console.log(state)
const mutations = {
    /* 登陆成功保存登陆信息 */
    [mutation.LOGIN_INFO](state, user) {
        if (user.id !== state.userInfo.id) {
            state.sideCheck = -1
        }
        state.userInfo = user
        // console.log("userInfo is " + JSON.stringify(state.userInfo))
        sessionStorage.setItem('userInfo', JSON.stringify(user))
    },
    /* 查看设备池详情跳转时保存信息 */
    [mutation.CASE_DETAIL](state, caseInfo) {
        // console.log(caseInfo)
        for (let v in caseInfo) {
            if (typeof v === "number") {
                caseInfo[v] = v + ""
            }
        }
        state.caseInfo = caseInfo
        sessionStorage.setItem('caseInfo', JSON.stringify(caseInfo))
    },

    /* 保存查看详情的appId */
    [mutation.APP_DETAIL](state, appInfo) {
        state.appInfo = appInfo
        sessionStorage.setItem('appInfo', JSON.stringify(appInfo))
    },
    /* 保存要操作的分组的信息 */
    [mutation.GROUP_DETAIL](state, groupInfo) {
        state.groupInfo = groupInfo
        sessionStorage.setItem('groupInfo', JSON.stringify(groupInfo))
    },
    /* 保存sideBar的checked */
    [mutation.SIDE_CHECK](state, checked) {
        state.sideCheck = checked
        state.sceneCheck = 0
        state.sceneChildShow = false
        state.sceneChildCheck = 0
        sessionStorage.setItem('sideCheck', JSON.stringify(checked))
    },
    /* 保存mainScene的checked */
    [mutation.SCENE_CHECK](state, data) {
        data.scene ? state.sceneChildCheck = data.checked : state.sceneCheck = data.checked
        sessionStorage.setItem(data.scene ? 'sceneChildCheck' : 'sceneCheck', JSON.stringify(data.checked))
    },
    /* 保存token过期回到登陆界面前的路由 */
    [mutation.LOGIN_FORWARD_PATH](state, path) {
        state.loginForwardPath = path
        sessionStorage.setItem('loginForwardPath', JSON.stringify(path))
    },
    /* 保存oreki——ip */
    [mutation.EXTRANET_IP](state, ip) {
        state.extranetIp = ip
        sessionStorage.setItem('extranetIp', JSON.stringify(ip))
    },
    /* 保存web——ip */
    [mutation.WEB_IP](state, ip) {
        state.webIp = ip
        sessionStorage.setItem('webIp', JSON.stringify(ip))
    },
    /* 保存fun */
    [mutation.FUN](state, funList) {
        state.funList = funList
        let sceneList = []
        for (let i in funList) {
            sceneList.push({
                name: funList[i].title,
                path: "/home/help/fun/show?index=" + i,
                author: "_0200_"
            })
        }
        help.children[1].sceneList = sceneList
        /*if (state.sideItems.indexOf(admin) >= 0) {
          state.sideItems = [...sideItems, ]
        }*/
        sessionStorage.setItem('funList', JSON.stringify(funList))
    },
    /* 保存change fun */
    [mutation.CHANGE_FUN](state, fun) {
        state.changeFun = fun
        // sessionStorage.setItem('changeFun', JSON.stringify(fun))
    },
    /* 保存guide */
    [mutation.GUIDE](state, guide) {
        state.guide = guide
    },
    /* 特殊进入 */
    [mutation.MANAGE](state, isManage) {
        if (isManage) {
            state.sideItems = [...sideItems, admin]
        } else {
            //从sideItems中去掉admin的内容
            state.sideItems = state.sideItems.filter(item => item.src !== admin.src);
        }
    },
    /* 登录过期 */
    [mutation.LOGIN_TIMEOUT](state, timeout) {
        state.loginTimeout = timeout
    },
    [mutation.LOGIN_ERROR](state, err_msg) {
        state.loginError = err_msg
    },
    /* 保存跳转到分组日志的分组id */
    [mutation.LOG_GROUP_ID](state, id) {
        state.logGroupId = id
    },
    /* 保存显示模式 */
    [mutation.GROUP_DEV_SHOW_MODE](state, mode) {
        state.groupDevShowMode = mode
        sessionStorage.setItem('groupDevShowMode', JSON.stringify(mode))
    },
    /* 设置设备控制窗口状态 */
    [mutation.DEVICE_WINDOW_SHOW_MODE](state, mode) {
        if (mode.show) {
            state.deviceWindowMode.push(mode.mode)
            // state.deviceWindowMode.push(mode)
            // console.log("deviceWindowMode is " + JSON.stringify(state.deviceWindowMode))
        } else {
            state.deviceWindowMode.splice(state.deviceWindowMode.indexOf(mode.mode), 1)
            // state.deviceWindowMode.splice(state.deviceWindowMode.indexOf(mode), 1)
        }
    },
    /* 重排设备控制窗口状态 */
    [mutation.DEVICE_WINDOW_SHOW_LATEST](state, id) {
        let showOne = null
        state.deviceWindowMode.forEach((mode,index) =>{
            if (mode && mode.id == id) {
                showOne = JSON.parse(JSON.stringify(mode))
                state.deviceWindowMode.splice(index, 1)
            }
        })
        if (showOne) {
            state.deviceWindowMode.push(showOne)
        }

    },
    /* 设置摄像头窗口状态 */
    [mutation.CAMERA_SHOW_MODE](state, mode) {
        let array = state.cameraInfo.filter(camera => camera.videoDeviceId === mode.videoDeviceId)

        if (mode.display) {
            state.cameraInfo.forEach((v, i) => {
                if (mode.videoDeviceId === v.videoDeviceId) {
                    v.show = mode.show
                }
            })
            return
        }

        let camera
        if (mode.show) {
            if (array.length === 0) {
                camera = {
                    show: true,
                    weight: 0,
                    left: mode.left,
                    top: mode.top,
                    label: mode.label,
                    videoDeviceId: mode.videoDeviceId
                }
                state.cameraInfo.push(camera)
            } else {
                camera = array[0]
            }
        } else {
            camera = array[0]
        }
        mode.show ? camera.weight++ : camera.weight--
        if (camera.weight === 0) {
            state.cameraInfo.splice(state.cameraInfo.indexOf(camera), 1)
        }
    },
    /* 设置视频窗口状态 */
    [mutation.VIDEO_SHOW_MODE](state, mode) {
        if (mode.display) {
            state.videoInfo.forEach((v, i) => {
                if (mode.id === v.id) {
                    v.show = mode.show
                }
            })
            return
        }
        // console.log(mode.mode)
        if (mode.show) {
            // console.log(JSON.stringify(mode.mode))
            state.videoInfo.push(mode.mode)
        } else {
            let index = -1
            let indexP = -1
            let only = false
            state.videoInfo.forEach((v, i) => {
                only = v.players.length === 1
                v.players.forEach((p, j) => {
                    if (p === (mode.ref || mode.player)) {
                        index = i
                        indexP = j
                    }
                })
            })
            if (only) {
                // console.log("2222222222222222")
                state.videoInfo.splice(index, 1)
            } else {
                // console.log("333333333333333")
                state.videoInfo[index].players.splice(indexP, 1)
            }
        }
    },
    /* 设置设备控制窗口状态 */
    [mutation.DEVICE_SYNC_SHOW_MODE](state, mode) {
        state.devSyncInfo.mainDev = mode.mainDev;
        state.devSyncInfo.syncDevs = mode.syncDevs;
    },
    /* 设置sideItem信息 */
    [mutation.SIDE_INFO](state, sideInfo) {
        state.sideInfo = JSON.parse(JSON.stringify(sideInfo))
        sessionStorage.setItem('sideInfo', JSON.stringify(sideInfo))
    },
    /* 设置用户管理员状态 */
    [mutation.IS_ADMIN_ROOT](state, isAdminRoot) {
        state.isAdminRoot = isAdminRoot
        sessionStorage.setItem('isAdminRoot', JSON.stringify(isAdminRoot))
    },
    /* 设置用户管理员状态 */
    [mutation.IS_ADMIN](state, isAdmin) {
        state.isAdmin = isAdmin
        sessionStorage.setItem('isAdmin', JSON.stringify(isAdmin))
    },
    /* 设置是否需要激活系统 */
    [mutation.IS_NEED_LICENSE](state, needLicense) {
        state.needLicense = needLicense
        sessionStorage.setItem('needLicense', JSON.stringify(needLicense))
    },
    /* 设置是否需要分层 */
    [mutation.IS_NEED_LAYER](state, needLayer) {
        // console.log("needLayer is " + needLayer)
        state.needLayer = needLayer
        sessionStorage.setItem('needLayer', JSON.stringify(needLayer))
    },
    /*  */
    [mutation.LICENSE_UPDATE](state, licenseUpdate) {
        state.licenseUpdate = licenseUpdate
        // sessionStorage.setItem('licenseUpdate', JSON.stringify(licenseUpdate))
    },
    [mutation.LICENSE_SAVE](state, licenseInfo) {
        state.licenseInfo = JSON.parse(JSON.stringify(licenseInfo))
        // console.log("LICENSE_SAVE: " + JSON.stringify(state.licenseInfo))
        // sessionStorage.setItem('licenseInfo', JSON.stringify(licenseInfo))
    },
    /*  */
    [mutation.HELP_INDEX](state, index) {
        state.helpIndex = index
        // sessionStorage.setItem('licenseUpdate', JSON.stringify(licenseUpdate))
    },
    /*  */
    [mutation.VISIT_PAGE](state, page) {
        let repeatBool = false
        state.latelyPages.forEach(p => {
            if (p.path === page.path) {
                repeatBool = true
            }
        })
        if (!repeatBool) {
            if (state.latelyPages.length < 4) {
                state.latelyPages.push(page)
            } else {
                state.latelyPages.splice(0, 1)
                state.latelyPages.push(page)
            }
        }

        if (!state.normalPageInfo[page.path]) {
            state.normalPageInfo[page.path] = {
                name: page.name,
                path: page.path,
                weight: 0
            }
        }
        state.normalPageInfo[page.path].weight++
        sessionStorage.setItem('latelyPages', JSON.stringify(state.latelyPages))
        sessionStorage.setItem('normalPageInfo', JSON.stringify(state.normalPageInfo))
    },
    /*  */
    [mutation.ENABLE_IP_PROXY](state) {
        let needPush = true
        if (state.sideItems[5].children) {
            state.sideItems[5].children.forEach(item => {
                if (item.path === "/home/system/ipproxy") {
                    needPush = false
                }
            })
        }
        if (needPush) {
            state.sideItems[5].children.push({
                name: "IP代理池",
                path: '/home/system/ipproxy',
                author: '_0001_',
                queryAuthor: "31-1",
                updateAuthor: "31-0",
            })
        }
        // sessionStorage.setItem('licenseUpdate', JSON.stringify(licenseUpdate))
    },
    [mutation.ENABLE_CMD_FORWARD](state) {
        let needPush = true
        if (state.sideItems[1].children) {
            state.sideItems[1].children.forEach(item => {
                if (item.path === "/home/cmdForward") {
                    needPush = false
                }
            })
        }
        if (needPush) {
            state.sideItems[1].children.push({
                name: "命令转发",
                path: '/home/cmdForward',
                author: '_0002_',
                queryAuthor: "32-1",
                updateAuthor: "32-0",
                sceneList: [
                    {
                        name: "转发记录",
                        path: "/home/forwardRecord",
                        author: "_0201_",
                        queryAuthor: "32_1-1",
                        updateAuthor: "32_1-0",
                    }
                ]
            })
        }
        // sessionStorage.setItem('licenseUpdate', JSON.stringify(licenseUpdate))
    },
    [mutation.ENABLE_CONTAINER_MIRROR](state) {
        let needPush = true
        if (state.sideItems[1].children) {
            state.sideItems[1].children.forEach(item => {
                if (item.path === "/home/mirrorList") {
                    needPush = false
                }
            })
        }
        if (needPush) {
            state.sideItems[1].children.push({
                name: "镜像列表",
                path: '/home/mirrorList',
                author: '_0002_',
                queryAuthor: "35-1",
                updateAuthor: "35-0",
                sceneList: [
                    {
                        name: "镜像记录",
                        path: "/home/mirrorRecord",
                        author: "_0201_",
                        queryAuthor: "35_1-1",
                        updateAuthor: "35_1-0",
                    }
                ]
            })
        }
    },
    [mutation.ENABLE_PHONE_MODEL](state) {
        let needPush = true
        if (state.sideItems[5].children) {
            state.sideItems[5].children.forEach(item => {
                if (item.path === "/home/system/phonemodel") {
                    needPush = false
                }
            })
        }
        if (needPush) {
            state.sideItems[5].children.push({
                name: "设备机型池",
                path: '/home/system/phonemodel',
                author: '_0001_',
                queryAuthor: "34-1",
                updateAuthor: "34-0",
            })
        }
        // sessionStorage.setItem('licenseUpdate', JSON.stringify(licenseUpdate))
    },
    [mutation.ENABLE_DEV_MASTER](state) {
        // console.log('1111111111 ENABLE_DEV_MASTER')
        if (!state.isAdmin) {
            let needPush = true
            if (state.busSideItems[0] && state.busSideItems[0].sceneList) {
                state.busSideItems[0].sceneList.forEach(item => {
                    if (item.path === "/home/group/devMaster") {
                        needPush = false
                    }
                })
            }
            if (needPush) {
                state.busSideItems[0].sceneList.push({
                    name: "备份管理",
                    path: '/home/group/devMaster',
                    author: '_0201_',
                })
            }
           
            return
        }

        if (state.sideItems[1].children[2] && state.sideItems[1].children[2].sceneList) {
            let hasPushed = false
            state.sideItems[1].children[2].sceneList.forEach(item => {
                if (item.path === "/home/group/devMaster") {
                    hasPushed = true
                }
            })
            if (!hasPushed) {
                state.sideItems[1].children[2].sceneList.push({
                    name: "备份管理",
                    path: '/home/group/devMaster',
                    author: '_0201_',
                })
            }
          
        } else {
            let sceneList = []
            sceneList.push({
                name: "备份管理",
                path: '/home/group/devMaster',
                author: '_0201_',
            })

            state.sideItems[1].children[2].sceneList = sceneList
        }

        let needPush = 1
        if (state.sideItems[2].children) {
            // console.log(JSON.stringify(state.sideItems[2].children))
            state.sideItems[2].children.forEach(item => {
                if (item.path === "/home/app/devMaster") {
                    needPush = 0
                }
            })
            if (needPush === 1) {
                state.sideItems[2].children.push({
                    name: "应用备份",
                    path: '/home/app/devMaster',
                    author: '_0301_',
                    queryAuthor: "33-1",
                    updateAuthor: "33-0",
                    sceneList: [
                        {
                            name: "新建备份",
                            path: "/home/app/devMaster/new",
                            author: "_0301_",
                            queryAuthor: "33_1-1",
                            updateAuthor: "33_1-0",
                        }
                    ]
                })
            }
        }
    },
    [mutation.DEV_INFO](state, info) {
        state.devInfo = info
        sessionStorage.setItem('devInfo', JSON.stringify(info))
    },
    [mutation.SSH_INFO](state, ssh) {
        state.ssh = ssh
    },
    [mutation.LOGIN_STATE](state, loginState) {
        state.loginState = loginState
        // sessionStorage.setItem('loginState', JSON.stringify(loginNow))
    },
    [mutation.LOGIN_NOW](state, loginNow) {
        state.loginNow = loginNow
        sessionStorage.setItem('loginNow', JSON.stringify(loginNow))
    },
    [mutation.DISPLAY_MODE](state, mode) {
        state.displayMode = mode
        sessionStorage.setItem('displayMode', JSON.stringify(mode))
    },
    [mutation.SCALE_MODE](state, mode) {
        state.scaleMode = mode
        sessionStorage.setItem('scaleMode', JSON.stringify(mode))
    },
    [mutation.SORT_MODE](state, mode) {
        state.sortMode = mode
        sessionStorage.setItem('sortMode', JSON.stringify(mode))
    },
    [mutation.REFRESH_TIME](state, mode) {
        state.refreshTime = mode
        sessionStorage.setItem('refreshTime', JSON.stringify(mode))
    },
    [mutation.FILE_RECORD_ID](state, id) {
        state.fileRecordId = id
        sessionStorage.setItem('fileRecordId', JSON.stringify(id))
    },
    [mutation.FILE_ISSUE_INFO](state, info) {
        state.fileIssueInfo = info
        sessionStorage.setItem('fileIssueInfo', JSON.stringify(info))
    },
    [mutation.DISPLAY_SIDE](state, bool) {
        state.displaySide = bool
    },
    [mutation.MIRROR_RECORD](state, record) {
        state.mirrorRecord = record
    },
    [mutation.SET_IS_MOBILE](state, isMobile) {
        state.isMobile = isMobile
        sessionStorage.setItem('isMobile', JSON.stringify(isMobile))
    }
}
const actions = {
    /* 登陆 */
    [action.LOGIN]({commit, state}, loginInfo) {
        let that = vm
        commit(mutation.LOGIN_STATE, true)
        that.$post(that.$uri.login.login, loginInfo).then(res => {
            // console.log("login res " + JSON.stringify(res))
            if (res.success) {
                res.data.save = loginInfo.save
                // this.$store.state.loginState = true
                commit(mutation.LOGIN_INFO, res.data)
                commit(mutation.LOGIN_NOW, true)
                commit(mutation.IS_ADMIN_ROOT, res.data.groupId === 1)
                commit(mutation.IS_ADMIN, res.data.groupType === 1)
                // console.log("login res is " + JSON.stringify(res.data))
                if (res.data.isGoogleAuthenticator) {
                    // console.log("设置了谷歌验证")
                    router.push('/googleLogin')
                } else {
                    router.push(res.data.groupType === 1 ? "/home" : '/home/group/list')
                }
            } else {
                if (res.code == "10025") { //IP白名单校验失败
                    // console.log("白名单校验失败[LOGIN]")
                    router.push('/ipForbidden?msg=' + res.message)
                }
            }
        })
    },
    /* 登陆 */
    [action.GOOGLE_LOGIN]({commit, state}, googleParam) {
        let that = vm
        // console.log("111111111111111111111")
        that.$post(that.$uri.login.googleLogin, googleParam).then(res => {
            // console.log("google_login res " + JSON.stringify(res))
            if (res.success) {
                commit(mutation.LOGIN_INFO, res.data)
                commit(mutation.LOGIN_NOW, true)
                // console.log("google_login res is " + JSON.stringify(res.data))
                router.push(res.data.groupType === 1 ? "/home" : '/home/group/list')
            }
        })
    },
    /* 查看设备池详情 */
    [action.GO_CASE_DETAIL]({commit}, caseInfo) {
        for (let v in caseInfo) {
            if (typeof v === "number") {
                caseInfo[v] = v + ""
            }
        }
        commit(mutation.CASE_DETAIL, caseInfo)
        commit(mutation.SIDE_CHECK, 0)
        // commit(mutation.SCENE_CHECK, 0)
        router.push("/home/deviceCaseDetail")
    },
    /* 查看设备列表 */
    [action.GO_CASE_DEV]({commit}, caseInfo) {
        for (let v in caseInfo) {
            if (typeof v === "number") {
                caseInfo[v] = v + ""
            }
        }
        commit(mutation.CASE_DETAIL, caseInfo)
        commit(mutation.SIDE_CHECK, 0)
        // commit(mutation.SCENE_CHECK, 0)
        router.push("/home/deviceCaseDev")
    },
    /* 跳转帮助文档 */
    [action.GO_FUN]({commit}, funTitle) {
        let that = vm
        that.$post(that.$uri.help.funList, {}).then(r => {
            if (r.success) {
                commit(mutation.FUN, r.list)
                let index = -1
                for (let i = 0; i < r.list.length; i++) {
                    if (r.list[i].title === funTitle) {
                        index = i
                        break
                    }
                }
                if (index !== -1) {
                    commit(mutation.HELP_INDEX, index)
                    router.push("/home/help/fun/show?index=" + index)
                }
            }
        })
    },
    /* 检查是否为移动设备 */
    [action.CHECK_IS_MOBILE]({commit}) {
        // 检查是否为移动设备的函数
        const isMobile = () => {
            const userAgentInfo = navigator.userAgent.toLowerCase();
            const mobileAgents = ['android', 'iphone', 'symbianos', 'windows phone', 'ipad', 'ipod'];
            let isMobile = false;
            
            // 根据userAgent判断
            for (let i = 0; i < mobileAgents.length; i++) {
                if (userAgentInfo.indexOf(mobileAgents[i]) > -1) {
                    isMobile = true;
                    break;
                }
            }
            
            // 根据屏幕宽度判断
            if (window.innerWidth <= 768) {
                isMobile = true;
            }
            
            // 判断是否是鸿蒙系统
            if (userAgentInfo.indexOf('openharmony') > -1) {
                //进一步判断类型
                if (userAgentInfo.indexOf('phone') > -1 || userAgentInfo.indexOf('tablet') > -1) {
                    isMobile = true;
                }
            }
            
            return isMobile;
        };
        
        commit(mutation.SET_IS_MOBILE, isMobile());
    }
}
const getters = {
    /* 检查是否有当前模块的修改权限 */
    checkChangeAuth: (state) => () => {
        if (state.isAdminRoot) {
            return true
        }
        let auth = ''
        if (state.sideInfo.child) {
            auth = state.sideInfo.child.queryAuthor
        }
        return state.userInfo.authority.indexOf(auth) !== -1
    },
   
    /* 获取推流地址 */
    shinoIp: (state) => () => {
        let shinoIp = (state.extranetIp || state.webIp) === state.webIp ? "0.0.0.0" : state.extranetIp
        if (shinoIp.indexOf(":") > 0) {
            shinoIp = shinoIp.substr(0, shinoIp.indexOf(":"))
        }
        return shinoIp;
    },
    groupAuthList: (state) => {
        let optList = []
        let viewList = []
        // console.log("sideItems is " + JSON.stringify(state.sideItems))
        state.sideItems.forEach(side => {
            let opt = {
                id: side.updateAuthor,
                query: side.queryAuthor,
                label: side.name,
            }
            let view = {
                id: side.queryAuthor,
                label: side.name,
            }

            if (side.children) {
                opt.children = []
                view.children = []

                side.children.forEach(child => {
                    opt.children.push({
                        id: side.updateAuthor + ',' + child.updateAuthor,
                        query: side.queryAuthor + ',' + child.queryAuthor,
                        label: child.name
                    })

                    view.children.push({
                        id: side.queryAuthor + ',' + child.queryAuthor,
                        label: child.name
                    })
                })
            }

            if (side.name) {
                if (side.updateAuthor) {
                    optList.push(opt)
                }
                viewList.push(view)
            }
        })

        return {
            optData: optList,
            viewData: viewList
        }
    },
    /* 获取权限过滤后的展示信息 */
    authorItems: (state) => {
        let list = []
        if (state.isAdminRoot) {
            let needPush = true
            if (state.sideItems[5].children) {
                state.sideItems[5].children.forEach(item => {
                    if (item.path === "/home/system/ssh") {
                        needPush = false
                    }
                })
            }
            if (needPush) {
                // if (vm.$isEnable(vm.$enableKey.webSsh)) {
                state.sideItems[5].children.push({
                    name: "SSH",
                    path: '/home/system/ssh',
                    author: '_0001_',
                    queryAuthor: "40-1",
                    updateAuthor: "40-0",
                })
            }
            return state.sideItems
        }

        if (!state.isAdmin) {
            //增加判断是否属于移动端用户
            if (state.isMobile) {
                return state.mobileSideItems
            }
            return state.busSideItems
        }

        state.sideItems.forEach(i => {
            if (state.userInfo.authority.indexOf(i.authorCode) !== -1) {
                list.push(i)

                let children = i.children
                if (children) {
                    for (let j = children.length - 1; j >= 0; j--) {
                        if (state.userInfo.authority.indexOf(children[j].queryAuthor) === -1) {
                            children.splice(j, 1);
                        }
                    }
                }
            }
        })
        return list
    },
    isChildren: (state) => (path) => {
        let page = null
        state.sideItems.forEach(side => {
            if (side.children) {
                side.children.forEach(child => {
                    if (child.path === path) {
                        page = {
                            name: child.name,
                            path: child.path
                        }
                    }
                })
            }
        })
        return page
    },
    /* 获取scene list */
    sceneList: (state) => {
        return state.sideItems[state.sideCheck].children[state.sceneCheck].sceneList
    },
   
    /* 获取请求头部 */
    getHeaders: (state) => {
        return {
            userId: state.userInfo.id,
            username: state.userInfo.username,
            token: state.userInfo.token
        }
    },
    /* 判断用户是否有权限 */
    checkChildAuthor: (state) => (authorCode) => {
        return state.userInfo.authority.indexOf(authorCode) !== -1
    },
    /* 判断引导弹窗是否显示 */
    isGuideShow: (state) => (popNum) => {
        return state.guide === popNum
    },
    latelyPages: (state) => {
        return state.latelyPages.slice(0, state.latelyPages.length).reverse()
    },
    normalPages: (state) => {
        let list = []
        for (let key in state.normalPageInfo) {
            list.push(state.normalPageInfo[key])
        }
        return list.slice(0, list.length > 4 ? 4 : list.length).sort((a1, a2) => {
            return a2.weight - a1.weight
        })
    },
    /* 获取设备池详情页面所需的list */
    detailTableList: () => {
        let list = []

        return list
    },
    videoDisplay: (state) => (id) => {
        for (let i = 0; i < state.videoInfo.length; i++) {
            if (id === state.videoInfo[i].id) {
                return state.videoInfo[i].show
            }
        }

        return false
    },
    getCameraWeight: (state) => (videoDeviceId) => {
        for (let i = 0; i < state.cameraInfo.length; i++) {
            if (videoDeviceId === state.cameraInfo[i].videoDeviceId) {
                return state.cameraInfo[i].weight
            }
        }
        return 0
    },
    getCameraShow: (state) => (videoDeviceId) => {
        for (let i = 0; i < state.cameraInfo.length; i++) {
            if (videoDeviceId === state.cameraInfo[i].videoDeviceId) {
                return state.cameraInfo[i].show
            }
        }
        return false
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    plugins: [createPersistedState({
            filter: (mutation) => {
                // console.log(mutation)
                if (mutation.type.indexOf("VIDEO_SHOW_MODE") !== -1) {
                    return false
                } else if (mutation.type.indexOf("LOGIN_TIMEOUT") !== -1) {
                    return false
                } else {
                    return true
                }
            }
        })]
});
